import { ActionReducerMap } from '@ngrx/store';
import { PermWizardStates } from '../states';

import * as fromPermWizardReducers from './permission-wizard.reducers';

export const permWizReducers: ActionReducerMap<PermWizardStates> = {
    permWizard: fromPermWizardReducers.permWizardReducer
};